const routes = {
  admin: {
    dashboard: {
      departmentGraphUrl: "/api/admin/getDepartmentGraphs",
      domainGraphUrl: "/api/admin/getDomainGraph",
      statsUrl: "/api/admin/getAdminStatsData",
    },
    studentAccess: {
      deleteAStudentUrl: "/api/admin/deleteAStudent",
      downloadStudentsDataCsvUrl: "/api/admin/student/download/students.csv",
      studentsAccessUrl: "/api/admin/getAllStudent",
      uploadStudentsDataCsvUrl: "/api/admin/uploadStudent",
    },
    teacherAccess: {
      deleteATeacherUrl: "/api/admin/deleteATeacher",
      downloadTeachersDataCsvUrl: "/api/admin/teacher/download/teachers.csv",
      teachersAccessUrl: "/api/admin/getAllTeacher",
      uploadTeachersDataCsvUrl: "/api/admin/uploadTeacher",
    },
  },
  landingPage: {
    adminLoginUrl: "/auth/adminLogin",
    statsUrl: "/auth/getStatsDataWithoutAuth",
    studentLoginUrl: "/auth/studentLogin",
    teacherLoginUrl: "/auth/teacherLogin",
  },
  teacher: {
    guidedProjects: { 
      guidedProjectsUrl: "/api/teacher/teacherProfile" 
    },
    starredProjects: {
      starredProjectsUrl: "/api/teacher/teacherStarredProject",
    },
    ongoingProjects: {
      closeProject: "/api/project/closeProject",
      createProject: "/api/project/createProject",
      deleteProject: "/api/project/deleteAProject",
      ongoingProjectDetailsUrl: "/api/project/OngoingProjectDetails",
      ongoingProjectListUrl: "/api/project/teacherOngoingProjectList",
      updateDeadline: "/api/project/updateDeadline",
    },
    profileDetails: {
      changePasswordUrl: "/auth/reset-password",
      fetchUserDetailsUrl: "/api/teacher/getTeacherProfileEditDetails",
      changeUserDetailsUrl: "/api/teacher/updateTeacherProfile",
      userInfoUrl: "/api/teacher/teacherProfile",
    },
  },
  student: {
    completedProjects: { completedProjectsUrl: "/api/student/studentProfile" },
    starredProjects: {
      starredProjectsUrl: "/api/student/studentStarredProject",
    },
    profileDetails: {
      changePasswordUrl: "/api/student/changePassword",
      fetchUserDetailsUrl: "/api/student/getStudentProfileEditDetails",
      changeUserDetailsUrl: "/api/student/updateStudentProfile",
      userInfoUrl: "/api/student/studentProfile",
    },
  },
  project: {
    allProjects: "/api/project/getAllProject",
    projectDetails: "/api/project/getProjectDetails",
    projectStars: "/api/project/getAllStar",
  },
  common: {
    activeDomainsUrl: "/api/student/getActiveDomains",
    activeTagsUrl: "/api/student/getActiveTags",
    departmentsUrl: "/api/teacher/getActiveDepartments"
  }
};

export default routes;
